import type { AsyncState } from '../../../platform/async/Async'
import type { Insight, InsightSeverity, Insights } from '../../insights/insightsWire'

/** What the card shows: the first insight as served, and how many there are. */
export type InsightView = { insight: Insight; count: number; currency: string }

/** Colour is never the only signal (rule 11): each severity carries a word. */
export const SEVERITY_TAG: Record<InsightSeverity, string> = { alert: 'Alert', warn: 'Warning', info: 'Notice' }

/**
 * The server orders most severe first, so the card shows `insights[0]` and
 * never re-sorts. Loading, empty and error pass through unchanged.
 */
export function toInsightState(state: AsyncState<Insights>): AsyncState<InsightView> {
  if (state.status !== 'success') return state as AsyncState<InsightView>
  const [insight] = state.data.insights
  if (insight === undefined) return { status: 'empty' }
  return { status: 'success', data: { insight, count: state.data.insights.length, currency: state.data.currency } }
}
